import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { OpkraevningResultComponent } from './opkraevning-result/opkraevning-result.component';
import { OpkraevningSearchComponent } from './opkraevning-search/opkraevning-search.component';
import { RisikoOpkraevningerService } from './risiko-opkraevninger.service';
import { RisikoOpkraevningDetailComponent } from './opkraevning-detail/risiko-opkraevning-detail.component';

@Component({
  selector: 'app-risikoopkraevning-opkraevninger',
  imports: [
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    ButtonModule,
    OpkraevningSearchComponent,
    OpkraevningResultComponent,
    RisikoOpkraevningDetailComponent,
  ],
  templateUrl: './risikoopkraevning-opkraevninger.component.html',
  styleUrl: './risikoopkraevning-opkraevninger.component.css',
})
export class RisikoopkraevningOpkraevningerComponent {
  opkraevningService = inject(RisikoOpkraevningerService);
  data = this.opkraevningService.datasource.data;
}
